module.exports = __webpack_public_path__ + "static/media/XLSX.9cac4e1e.svg";